<template>
  <div class="form-group">
    <label class="font-weight-bold" for="id_cidades_atuacao">
      {{ label }}
    </label>
    <b-row class="align-items-center">
      <b-col
        cols="12"
        sm="12"
        md="6"
        lg="6"
        class="d-flex align-items-center mb-2 mr-2"
        v-for="(selectedCities, index) in selects"
        :key="index"
      >
        <v-select
          label="nome"
          class="mr-2"
          v-model="selects[index]"
          :placeholder="placeholder"
          :options="searchResults"
          @input="onSelect($event, index)"
          @search="search"
          @search:focus="searchResults = []"
        >
          <div slot="no-options">
            {{ noOptionsText }}
          </div>
        </v-select>
        <b-button
          v-if="isOptional || (!isOptional && index !== 0)"
          pill
          class="delete-city d-flex justify-content-center"
          variant="danger"
          @click="removeSelect(index)"
        >
          <i class="fas fa-times"></i>
        </b-button>
      </b-col>
    </b-row>
    <p v-if="errorMessage !== null" class="error-message text-danger">
      {{ errorMessage }}
    </p>
    <b-row>
      <b-col cols="6">
        <b-button pill variant="success" class="mt-1" @click="addSelect">
          <i class="fas fa-plus mr-2"></i>
          {{ addButtonText }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import makeToast from 'Mixins/makeToast';

export default {
  name: 'SelectCitiesByUfId',
  mixins: [makeToast],
  props: {
    label: {
      type: String,
      required: true,
    },
    selectedCities: {
      type: Array,
      required: true,
    },
    ufId: {
      type: Number,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Selecione a(s) cidade(s)',
    },
    noOptionsText: {
      type: String,
      default: 'Digite para pesquisar a cidade desejada',
    },
    addButtonText: {
      type: String,
      default: 'Adicionar cidade',
    },
    isOptional: {
      type: Boolean,
      default: true,
    },
    errorMessage: {},
  },
  computed: {
    ...mapGetters('general', ['getIbgeCities']),
  },
  watch: {
    selectedCities() {
      this.selectedCityIds = this.selectedCities;
    },
  },
  data() {
    return {
      selects: [],
      /**
       *  @description Variable to store only the city ids of our database
       */
      selectedCityIds: [],
      searchResults: [],
      selectIndex: 0,
    };
  },
  created() {
    this.getAllCitiesByUfId(this.ufId);

    if (!this.isOptional && this.selectedCities.length === 0) {
      this.selects.push(null);
    }
  },
  methods: {
    ...mapActions('general', [
      'getAllCitiesByUfId',
      'verifyIfCityExistsByIbgeCode',
    ]),
    onSelect(selectedCity, index) {
      this.selectIndex = index;
      this.$emit('update:errorMessage', null);

      if (!selectedCity) {
        this.removeCity();
        return;
      }

      if (this.getIbgeCities.fromIbge) {
        this.verifyCity(selectedCity);
      } else {
        this.emitNewCity(selectedCity.id, index);
      }
    },
    verifyCity(city) {
      const cityData = {
        ibgeCode: city.id,
        cityName: city.nome,
      };

      this.verifyIfCityExistsByIbgeCode(cityData)
        .then((response) => {
          this.emitNewCity(response.data.cityId);
        })
        .catch(() => {
          this.makeToast(
            'Oopss!',
            'Houve um erro ao adicionar a cidade, por favor tente novamente',
            'danger'
          );
        });
    },
    emitNewCity(cityId) {
      if (!this.selectedCityIds.some((id) => id === cityId)) {
        this.selectedCityIds[this.selectIndex] = cityId;
        this.$emit('update:selectedCities', this.selectedCityIds);
      }
    },
    addSelect() {
      this.selects.push(null);
    },
    removeSelect(index) {
      this.selects.splice(index, 1);
      this.selectedCityIds.splice(index, 1);
      this.$emit('update:selectedCities', this.selectedCityIds);
    },
    removeCity() {
      this.selects[this.selectIndex] = null;
      this.selectedCityIds[this.selectIndex] = null;
      this.$emit('update:selectedCities', this.selectedCityIds);
    },
    search(search) {
      if (search.length >= 2) {
        this.searchResults = this.getIbgeCities.cities.filter((city) =>
          city.nome.toLowerCase().includes(search.toLowerCase())
        );
      }
    },
  },
};
</script>

<style scoped>
.delete-city {
  border-radius: 50%;
  width: 30px;
  height: 30px;
}
</style>
